import Box from '@mui/material/Box';
import React, { type ReactNode } from 'react';

type Props = {
  children: ReactNode;
  labelledBy: string;
};

export default function DrawerDialogSurface({ children, labelledBy }: Props): React.JSX.Element {
  return (
    <Box
      aria-labelledby={labelledBy}
      aria-modal='true'
      component='section'
      role='dialog'
      sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, width: '100%' }}
    >
      {children}
    </Box>
  );
}
